import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {GlobalDateService} from "../../../../_services/global-date.service";
import {GlobalDateFormat} from "../../../../enums/global-date-format";
import {DatePipe, NgClass} from "@angular/common";

@Component({
  selector: 'app-selectable-calendar',
  templateUrl: './selectable-calendar.component.html',
  imports: [
    NgClass,
    DatePipe
  ],
  styleUrls: ['./selectable-calendar.component.css']
})
export class SelectableCalendarComponent {
  today: Date = new Date();

  @Output() public dates: Date[] = [];


  @Input() activeDateChangedReceiver: EventEmitter<Date> = new EventEmitter<Date>();
  @Input() markedDates: Date[] = [];

  @Output() daySelected: EventEmitter<Date> = new EventEmitter<Date>();


  activeDate: Date = this.today;


  selectedStartCell?: Date = undefined;
  selectedEndCell?: Date = undefined;
  selectedCell?: Date = undefined;
  isMouseDown: boolean = false;
  isMultiSelectingActive: boolean = true;

  singleDaySelected?: Date = undefined


  @Output() endCellSelected = new EventEmitter<Date>();

  @Output() startCellSelected = new EventEmitter<Date>();

  @Output() monthChanged: EventEmitter<Date> = new EventEmitter<Date>();
  lastSelectedDay: Date | undefined;
  protected readonly Array = Array;
  protected readonly GlobalDateFormat = GlobalDateFormat;

  constructor(public globalDateService: GlobalDateService, private router: Router, private route: ActivatedRoute) {
    //this.createCalendarMonthView();
  }

  initWithDate(date: Date): void {
    setTimeout(() => {
      this.activeDate = date;
      this.createCalendarMonthView();
    }, 0);
  }

  public createCalendarMonthView(weekday: number = 1): void {
    this.dates = [];
    let dayCountCurrentMonth = new Date(this.activeDate.getFullYear(), this.activeDate.getMonth() + 1, 0).getDate();
    let firstDayOfMonthAsWeekday = ((new Date(this.activeDate.getFullYear(), this.activeDate.getMonth(), 1).getDay() - weekday) + 7) % 7;
    let dayCountPreviousMonth = new Date(this.activeDate.getFullYear(), this.activeDate.getMonth(), 0).getDate();


    for (let i = 0; i < firstDayOfMonthAsWeekday; i++) {
      this.dates.push(new Date(this.activeDate.getFullYear(), this.activeDate.getMonth() - 1, dayCountPreviousMonth - (firstDayOfMonthAsWeekday - i - 1)));
    }

    for (let i = 0; i < dayCountCurrentMonth; i++) {
      this.dates.push(new Date(this.activeDate.getFullYear(), this.activeDate.getMonth(), i + 1));
    }

    let dayCountNextMonth = 42 - this.dates.length;

    for (let i = 0; i < dayCountNextMonth; i++) {
      this.dates.push(new Date(this.activeDate.getFullYear(), this.activeDate.getMonth() + 1, i + 1));
    }


  }

  nextMonth(): void {
    this.activeDate = new Date(this.activeDate.getFullYear(), this.activeDate.getMonth() + 1, 1);
    this.createCalendarMonthView();
    this.monthChanged.emit(this.activeDate);
    this.setMonthInUrlAsQuerystring();
  }

  previousMonth(): void {
    this.activeDate = new Date(this.activeDate.getFullYear(), this.activeDate.getMonth() - 1, 1);
    this.createCalendarMonthView();
    this.monthChanged.emit(this.activeDate);
    this.setMonthInUrlAsQuerystring();
  }

  setMonthInUrlAsQuerystring(): void {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {
        month: this.activeDate.getMonth(),
        year: this.activeDate.getFullYear()
      },
      queryParamsHandling: 'merge'
    });
  }

  daySelectedEvent(date: Date): void {
    if (this.singleDaySelected == date) {
      this.singleDaySelected = undefined;
      this.daySelected.emit(undefined);
      return;
    }
    this.singleDaySelected = date;
    this.daySelected.emit(date);
  }

  select(date: Date): void {
    if (!this.isMultiSelectingActive) {
      this.selectedCell = date;
      this.selectedStartCell = date;
      this.selectedEndCell = date;
      this.emitStartCellSelected();
      return;
    }
    if (this.isMouseDown) {
      this.selectedEndCell = date;
      this.sortSelectedCells()
      this.isMouseDown = false;
      this.emitEndCellSelected();
      return;
    }
    this.selectedStartCell = date;
    this.selectedEndCell = date;
    this.selectedCell = date;
    this.isMouseDown = true;
    this.emitStartCellSelected();
  }

  isToday(date: Date): boolean {
    return date.getFullYear() == this.today.getFullYear() && date.getMonth() == this.today.getMonth() && date.getDate() == this.today.getDate();
  }

  isDayMarked(date: Date): boolean {
    return this.markedDates.some((markedDate: Date) => {
      return markedDate.getFullYear() == date.getFullYear() && markedDate.getMonth() == date.getMonth() && markedDate.getDate() == date.getDate();
    });
  }

  emitStartCellSelected(): void {
    if (this.selectedStartCell === undefined) return;
    this.startCellSelected.emit(this.selectedStartCell);
  }

  emitEndCellSelected(): void {
    if (this.selectedEndCell === undefined) return;
    this.endCellSelected.emit(this.selectedEndCell);
  }

  isSelected(date: Date): boolean {
    if (window.innerWidth < 768) {
      this.resetSelection();
      return false
    }
    if (this.selectedStartCell === undefined || this.selectedEndCell === undefined) {
      return false;
    }
    return date >= this.selectedStartCell && date <= this.selectedEndCell;
  }

  resetSelection(): void {
    this.selectedStartCell = undefined;
    this.selectedEndCell = undefined;
    this.selectedCell = undefined;
    this.isMouseDown = false;
  }

  sortSelectedCells(): void {
    if (this.selectedStartCell === undefined || this.selectedEndCell === undefined || this.selectedCell === undefined) {
      return;
    }
    if (this.selectedCell != this.selectedStartCell) {
      this.selectedStartCell = this.selectedCell;
    }

    if (this.selectedCell > this.selectedEndCell) {
      let temp = this.selectedStartCell;
      this.selectedStartCell = this.selectedEndCell;
      this.selectedEndCell = temp;
    }
  }

  multiSelectedOver(date: Date): void {
    if (!this.isMouseDown) return;
    if (this.selectedStartCell === undefined) {
      return;
    }
    this.selectedEndCell = date;
    this.sortSelectedCells();
  }

  ngOnInit(): void {
    this.daySelected.subscribe({
      next: (date: Date) => {
        this.lastSelectedDay = date;
      }
    })
  }
}
